"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }// A module that needs to stop the message going out (lane D's template with
// an unfilled variable, say) reports a blocked gate with a reason. A blocked
// gate disables Send and Send later together; the reason is for assistive
// tech and a tooltip, never a substitute for the module's own UI.








 const OPEN_SEND_GATE = Object.freeze({ blocked: false }); exports.OPEN_SEND_GATE = OPEN_SEND_GATE

 const blockSend = (reason) => ({ blocked: true, reason }); exports.blockSend = blockSend

// The first blocked gate wins, so its reason is the one shown.
 const combineSendGates = (gates) =>
  gates.find(gate => _optionalChain([gate, 'optionalAccess', _ => _.blocked])) || exports.OPEN_SEND_GATE; exports.combineSendGates = combineSendGates
